let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:9090';
} else if (hostname === 'staff.symbev.thewebpeople.ca') {
    backendHost = 'https://staff.symbev.thewebpeople.ca';
} else {
    backendHost = 'https://staff.symbevbrands.com';
}

export const API_ROOT = `${backendHost}/api`;